var $530d6fbe3f80ba06$exports = {};
$530d6fbe3f80ba06$exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};


export {$530d6fbe3f80ba06$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
